import(/* webpackMode: "eager", webpackExports: ["FooterV2"] */ "/vercel/path0/src/components/landing-v2/shared/footer-v2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavV2"] */ "/vercel/path0/src/components/landing-v2/shared/nav-v2.tsx");
